import { render, staticRenderFns } from "./Express.vue?vue&type=template&id=543b48b6&scoped=true&"
import script from "./Express.vue?vue&type=script&lang=js&"
export * from "./Express.vue?vue&type=script&lang=js&"
import style0 from "./Express.vue?vue&type=style&index=0&id=543b48b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543b48b6",
  null
  
)

export default component.exports